@use "../../style/variables" as *;
@use "../../style/mixins" as *;

.additional-data {

  padding-bottom: 6rem;
  margin-top: 8rem;

  @include mobile {
    margin-top: 0;
  }

  .container {
    padding-top: 0;
    @include mobile {
      padding-top: 2.75rem;
    }
  }

  .flex {
    display: flex;
    @include mobile {
      display: block;
    }
  }

  .container {
    margin-top: 2rem;
    width: 900px;
    max-width: 900px;

    @include mobile {
      margin-left: 1rem;
      margin-right: 1rem;
      width: auto;
    }
  }

  .info-text {
    text-align: center;
    font-weight: 300;
    margin-bottom: 2.5rem;
  }

  .your-store {
    display: flex;
    flex-direction: column;
    background-color: $white;
    width: 25rem;
    margin-bottom: 1rem;

    @include mobile {
      width: 100%;
    }
  }

  .about-you {
    display: flex;
    flex-direction: column;
    background-color: $white;
    width: 25rem;
    margin-bottom: 1rem;

    @include mobile {
      width: 100%;
    }
  }


  .divider {
    flex: 1 auto;

    @include mobile {
      display: none;
    }
  }

  .right {
    display: flex;
    justify-content: flex-end;
  }

  .button-continue button {
    margin-top: 2.7rem;
    font-size: 1rem;
    border-radius: 5px;
    width: 11.25rem;
    height: 2.8rem;

    @include mobile {
      margin-top: 2rem;
    }

    &:disabled {
      background: $grey-light;
    }

    @include mobile {
      font-size: 0.875rem;
      width: 10rem;
      height: 2.25rem;
    }
  }

}